import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../Inventory/viewInventory.css";
import Invoices from "../../api/Invoice";

const Invoice = props => (
    <tr>
        <td>{props.invoice.cName}</td>
        <td>{props.invoice.date}</td>
        <td>{props.invoice.invNo}</td>
        <td>{props.invoice.email}</td>
        <td>{props.invoice.mob}</td>
        <td>{props.invoice.address}</td>
        <td>{props.invoice.city}</td>
        <td>{props.invoice.company}</td>
        <td>{props.invoice.gst}</td>
        <td>
            <Link to={"/invoice/edit/" + props.invoice._id}><i className='bx bx-edit-alt'></i></Link> | <span onClick={() => { props.deleteInvoice(props.invoice._id) }} ><i className='bx bx-trash'></i></span> | <Link to={"/print-invoice/" + props.invoice._id}><i className='bx bx-printer'></i></Link>
        </td>
    </tr>
)

class viewInvoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            invoices: []
        }
        this.deleteInvoice = this.deleteInvoice.bind(this);
    }

    componentDidMount() {
        Invoices.get('/get-invoices')
            .then(res => {
                this.setState({ invoices: res.data })
            })
            .catch(error => console.log(error));
    }

    deleteInvoice(id) {
        Invoices.delete('/delete-invoice/' + id)
            .then(res => console.log(res.data));

        this.setState({ invoices: this.state.invoices.filter(el => el._id !== id) })
    }

    invoicesList() {
        return this.state.invoices.map(currentinvoice => {
            return <Invoice invoice={currentinvoice} deleteInvoice={this.deleteInvoice} key={currentinvoice._id} />
        })
    }

    render() {
        return (
            <div className='FideologyActivities'>
                <h3 className='fidoh3'>View Invoice</h3>
                <div className="fideo">
                    <table>
                        <thead className="thead-light">
                            <tr>
                                <th>Customer Name</th>
                                <th>Invoice Date</th>
                                <th>Invoice No</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Billing Address</th>
                                <th>City</th>
                                <th>Company Name</th>
                                <th>GST No.</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.invoicesList()}
                        </tbody>
                    </table>
                    <Link to='/add-invoice'><div className='add'>Add</div></Link>
                </div>
            </div>
        );
    }
}

export default viewInvoice;